export const OUTPUT_DATA_COMBINATION_REQUEST =
  "OUTPUT_DATA_COMBINATION_REQUEST";
export const OUTPUT_DATA_COMBINATION_SUCCESS =
  "OUTPUT_DATA_COMBINATION_SUCCESS";
export const OUTPUT_DATA_COMBINATION_FAILURE =
  "OUTPUT_DATA_COMBINATION_FAILURE";
